@let messages = this.messages();
@if (messages.length > 0) {
  <ul class="system-messages">
    @for (message of messages; track $index) {
      <li
        [attr.id]="message.id"
        [ngClass]="[
          'system-messages--message',
          `system-messages--message__${message.animationStatus}`,
          `system-messages--message__system-${message.statusColour}`,
        ]">
        @if (message.icon) {
          <fa-icon [icon]="message.icon" size="lg"></fa-icon>
        }
        <div>
          <h3>{{ message.title }}</h3>
          <p>{{ message.description }}</p>
        </div>
      </li>
    }
  </ul>
}
